import { AxiosError } from 'axios';
import { ToastContextType } from '../contexts/toastContext';

export const cleanStringSpaces = (string: string): string => {
  return (string ?? '').replace(/\s/g, '-').toLowerCase();
};

export const getUrlObject = (url): Partial<URL> => {
  try {
    let formattedUrl = url;
    const protocolRegex = new RegExp('(http|https)://', 'i');
    const wwwPrefix = new RegExp('www.', 'i');

    if (!wwwPrefix.test(formattedUrl)) {
      formattedUrl = `wwww.${formattedUrl}`;
    }

    if (!protocolRegex.test(formattedUrl)) {
      formattedUrl = `https://${formattedUrl}`;
    }

    return new URL(formattedUrl);
  } catch {
    return {};
  }
};

export const onAPIError = (
  error: AxiosError<any, any>,
  options: any,
  toast: ToastContextType
): void => {
  const status = error?.request?.status ?? error?.response?.status;
  if (status === 403) {
    const { method, url } = error.config;
    const errorMessage = `It seems you don't have access to some features on this page. Please contact support to get help. code: ${method} - ${url}`;
    toast.showErrorFeedback(errorMessage);
  } else if (!options?.onError) {
    const message =
      error?.response?.data?.message ??
      error?.message ??
      'Something went wrong. Please try again.';
    toast.showErrorFeedback(message);
  }
  if (options?.onError) {
    options?.onError(error);
  }
};

const wordsToNotCapitalize = ['and', 'of', 'with'];

export const capitalizeString = (word: string): string => {
  return word
    .replace(/\s|_/g, ' ')
    .split(' ')
    .map((e) => {
      return wordsToNotCapitalize.includes(e.toLowerCase())
        ? e.toLowerCase()
        : e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
    })
    .join(' ');
};

export const onScrollToSmoothly = (elementId: string): void => {
  const pageContent = document.getElementById('page-content');
  const elementScrollPosition = document.getElementById(elementId)?.offsetTop ?? 0;
  const headerHeight = 120;
  pageContent?.scroll({
    top: elementScrollPosition - headerHeight,
    behavior: 'smooth',
  });
};

const cleanString = (str: string): string => {
  return str.replace(/[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/g, '');
};

export const filterByWord = (label: string, search: string): boolean => {
  const cleanedInput = cleanString(search);
  const cleanedOption = cleanString(label);
  const caseInsensitiveRegex = new RegExp(`^${cleanedInput}`, 'i');

  return caseInsensitiveRegex.test(cleanedOption);
};
